import { DisplayModel } from './Model/DisplayModel';
import { useState, useRef } from 'react';
import { BasePopup } from './QuoteEstimate/BasePopup';
import ScrollAnimation from 'react-animate-on-scroll';
import { ContactUs } from './ContactUs';
import { Navigation } from './Navigation/Nav';
import { Chatbot } from './Chatbot/Chatbot';

// Landing page sections
import { HeroSection } from './Landing/HeroSection';
import { HowItWorks } from './Landing/HowItWorks';
import { Testimonials } from './Landing/Testimonials';
import { EarnSection } from './Landing/EarnSection';

export function Home() {
  const [modalShow, setModalShow] = useState(false);
  const [bodyPartsSelected, setBodyPartsSelected] = useState([]);
  const bodyModelRef = useRef(null);

  const scrollToBodyModel = () => {
    bodyModelRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Navigation />

      {/* Hero Section */}
      <HeroSection onGetStarted={scrollToBodyModel} />

      {/* How It Works */}
      <HowItWorks />

      {/* Body Model Section */}
      <section
        ref={bodyModelRef}
        id="body-model"
        className="qmi-body-model-section"
      >
        <BasePopup
          show={modalShow}
          bodyParts={bodyPartsSelected}
          onHide={() => setModalShow(false)}
        />
        <DisplayModel
          setModalShow={setModalShow}
          setBodyPartsSelected={setBodyPartsSelected}
        />
      </section>

      {/* Testimonials */}
      <Testimonials />

      {/* Earn by submitting leads */}
      <EarnSection />

      {/* Contact Us */}
      <ScrollAnimation animateIn="fadeIn" animateOnce={true} offset={100}>
        <ContactUs />
      </ScrollAnimation>

      <Chatbot />
    </>
  );
}
